import { useSnackbar } from "notistack";
import { GetAnswerUseCase } from "../../../../domain/usecase/answer/get/GetUseCase";
import { useEffect, useState } from "react";
import { Answer } from "../../../../domain/model/Question";
import { State } from "../../../../domain/model/ResponseState";
import { useSearchParams } from "react-router-dom";
import io, { Socket } from "socket.io-client";
import { SOCKET_URL } from "../../../../data/constant/ApiConstants";

export function QRCodeAnswersViewModel(
  answerId: string | undefined,
  getAnswerUseCase: GetAnswerUseCase
) {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [answer, setAnswer] = useState<Answer | undefined>();

  const [isDrawingMode, setIsDrawingMode] = useState(false);
  const [isDrawingStarted, setIsDrawingStarted] = useState(false);
  const [gameId, setGameId] = useState<string>();
  const [questionIndex, setQuestionIndex] = useState<number>();

  const [readyToDraw, setReadyToDraw] = useState(false);

  const [socket, setSocket] = useState<Socket | undefined>();

  useEffect(() => {
    if (!socket) return;

    const eventName = `status,${gameId},${questionIndex}`;
    socket.on(eventName, (data) => {
      if (data == "ready") {
        setReadyToDraw(true);
      } else if (data == "finished") {
        setReadyToDraw(false);
      }
    });

    function onError() {
      showSnackbar(
        "Error in connecting to socket io, reconnecting in 3 seconds!"
      );
    }
    function onConnect() {
      showSnackbar("Socket Connected", "success");
    }

    function onDisconnect() {
      showSnackbar("Socket Disconnected");
    }
    socket.io.on("error", onError);
    socket.on("connect", onConnect);
    socket.on("disconnect", onDisconnect);

    return () => {
      socket.io.off("error", onError);
      socket.off("connect", onConnect);
      socket.off("disconnect", onDisconnect);
    };
  }, [socket]);

  const searchParams = useSearchParams();

  useEffect(() => {
    getParams();
    getAnswer();
  }, []);

  function drawingStarted() {
    setIsDrawingStarted(true);
    const newSocket = io(SOCKET_URL, {
      reconnectionAttempts: 10,
      reconnectionDelay: 3000,
    });
    setSocket(newSocket);
  }

  function onDrawEnded(data: string) {
    if (socket) {
      socket.emit(`drawingImage,${gameId},${questionIndex}`, data);
      console.log("drawing ended");
    }
  }

  function getParams() {
    const drawingMode = searchParams[0].get("drawing") == "true";
    const gId = searchParams[0].get("game_id");
    const qIndex = searchParams[0].get("question_index");

    setIsDrawingMode(drawingMode);
    if (gId) setGameId(gId);
    if (qIndex) setQuestionIndex(Number(qIndex));
  }

  async function getAnswer() {
    if (!answerId) return;
    setLoading(true);
    const response = await getAnswerUseCase.invoke(answerId);
    setLoading(false);
    switch (response.responseState) {
      case State.Success:
        setAnswer(response.data);
        break;
      case State.Fail:
      case State.Error:
        showSnackbar(response.error?.message);
        break;
    }
  }

  function showSnackbar(
    message: string | undefined,
    variant: "error" | "success" = "error"
  ) {
    if (message) enqueueSnackbar(message, { variant: variant });
  }
  return {
    answer,
    loading,
    isDrawingMode,
    isDrawingStarted,
    onDrawEnded,
    drawingStarted,
    readyToDraw,
  };
}
